import React from 'react';
import { Citation } from '../../models/models';
import {
    CitationButton,
    CitationButtonsContainer,
    CitationCard,
    CitationContent
} from './ChatMessages.styled';

interface MessageCitationsProps {
    citations: Citation[];
    openIndex: number | null;
    onToggle: (index: number) => void;
}

export const MessageCitations: React.FC<MessageCitationsProps> = ({
    citations,
    openIndex,
    onToggle
}) => {
    if (!citations || citations.length === 0) {
        return null;
    }

    return (
        <>
            <CitationButtonsContainer>
                {citations.map((_, citIdx) => (
                    <CitationButton
                        key={`citation-btn-${citIdx}`}
                        $isActive={openIndex === citIdx}
                        onClick={() => onToggle(citIdx)}
                    >
                        <i className="fa-solid fa-quote-left"></i>
                        Cytat {citIdx + 1}
                    </CitationButton>
                ))}
            </CitationButtonsContainer>
            {openIndex !== null && citations[openIndex] && (
                <CitationCard style={{ marginTop: '12px' }}>
                    <CitationContent style={{ whiteSpace: 'pre-wrap' }}>
                        {citations[openIndex].content}
                    </CitationContent>
                </CitationCard>
            )}
        </>
    );
};
